export const HOME_GET_CODIGUERAS = 'HOME_GET_CODIGUERAS';
export const HOME_GET_MEDICAMENTOS = 'HOME_GET_MEDICAMENTOS';


